import type { GranularitySwitcherEnum } from "app/pages/industry-analysis/category-share/CategoryShareGraph/CategoryShareGraphTypes";
import type {
    ProWebsiteControllersApiWidgetAdIntelligenceChannelPerformanceData,
    ProWebsiteControllersApiWidgetAdIntelligencePerformanceOverTimeResponse,
} from "@similarweb/pro-api-client";

export type GranularityKey = keyof ProWebsiteControllersApiWidgetAdIntelligenceChannelPerformanceData;

export type ChannelKey = Exclude<
    keyof ProWebsiteControllersApiWidgetAdIntelligencePerformanceOverTimeResponse,
    "hasAdIntelMetrics"
>;

export const DISPLAY_MODES = {
    values: "values",
    percentage: "percentage",
} as const;

export type DisplayMode = (typeof DISPLAY_MODES)[keyof typeof DISPLAY_MODES];

export interface IPerformanceOverTimeGraphProps {
    defaultGranularity?: GranularitySwitcherEnum;
    hideGranularityFilter?: boolean;
}
